import { Component, Input } from '@angular/core';

@Component({
  selector: 'wz-info-tooltip',
  templateUrl: './info-tooltip.component.html',
  styleUrls: ['./info-tooltip.component.scss'],
  standalone: false,
})
export class InfoTooltipComponent {
  @Input() message!: string;
  @Input() outline = false;
  @Input() position: 'after' | 'below' | 'above' | 'before' | 'left' | 'right' =
    'below';
  get icon() {
    return this.outline ? 'info_outline' : 'info';
  }
}
